import { render, staticRenderFns } from "./NtdInstitutes.vue?vue&type=template&id=60e65096&scoped=true"
import script from "./NtdInstitutes.vue?vue&type=script&lang=ts"
export * from "./NtdInstitutes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e65096",
  null
  
)

export default component.exports